const MENULIST = 'menulist'
//  存菜单
function setMenuList(menuList) {
  localStorage.setItem(MENULIST, JSON.stringify(menuList))
}

//  取菜单
function getMenuList() {
  const menuList = localStorage.getItem(MENULIST)
  return JSON.parse(menuList)
}

//  删菜单
function removeMenuList() {
  localStorage.removeItem(MENULIST)
}
//  三级菜单
const PATHLIST = 'pathlist'
function setPathList(pathlist) {
  localStorage.setItem(PATHLIST, JSON.stringify(pathlist))
}
function getPathList() {
  return localStorage.getItem(PATHLIST)
}
function removePathList() {
  localStorage.removeItem(PATHLIST)
}
//  所有权限路径
const MENUPATHLIST = 'menupathlist'
function setMenuPathList(menupathlist) {
  localStorage.setItem(MENUPATHLIST, JSON.stringify(menupathlist))
}
function getMenuPathList() {
  return JSON.parse(localStorage.getItem(MENUPATHLIST))
}
function removeMenuPathList() {
  localStorage.removeItem(MENUPATHLIST)
}
//  所有按钮权限
const BUTTONLIST = 'buttonlist'
function setButtonList(buttonlist) {
  localStorage.setItem(BUTTONLIST, JSON.stringify(buttonlist))
}
function getButtonList() {
  return localStorage.getItem(BUTTONLIST)
}
function removeButtonList() {
  localStorage.removeItem(BUTTONLIST)
}

export { setMenuList, getMenuList, removeMenuList, setPathList, getPathList, removePathList, setMenuPathList, getMenuPathList, removeMenuPathList, setButtonList, getButtonList, removeButtonList}
